import { ArdoqIcon, ArdoqIconCategory } from '@ardoq/data-model';
import { colors } from '@ardoq/design-tokens';
import { fontAwesomeIcons } from '@ardoq/icons';
import { readableColor } from 'polished';
import { svgImage } from 'tabview/canvasRendering/canvasResolvedImages';
import { calculateIconLayout } from 'yfilesExtensions/styles/modernized/leafNode/util';

type CanvasRenderingContext =
  | CanvasRenderingContext2D
  | OffscreenCanvasRenderingContext2D;

const paintIcon = (
  context: CanvasRenderingContext,
  x: number,
  y: number,
  size: number,
  color: string,
  icon: ArdoqIcon
) => {
  const { id, category, isSVG } = icon;
  const layout = calculateIconLayout(x, y, size, icon);

  if (category === ArdoqIconCategory.FontAwesome) {
    context.font = `${size}px FontAwesome`;
    context.fillStyle = color;
    context.textBaseline = 'middle';
    context.textAlign = 'center';
    context.fillText(fontAwesomeIcons[id], x, y);
    return;
  }

  if (isSVG) {
    /** the color used to fill negative space in certain icons. */
    const negativeColor = readableColor(
      color,
      colors.transparent0,
      colors.white950
    );
    const img = svgImage(
      `${id}~~${color}~~${color}~~${''}~~100%~~${''}~~${negativeColor}`
    );
    if (img) {
      context.drawImage(img, layout.x, layout.y, layout.width, layout.height);
    }
  }
};
export { paintIcon };
